import React, { FC, useRef } from 'react'
import { Flex } from '@gassan-ui'
import { Menu, MenuLink } from '@reach/menu-button'
import { Text } from '@rolex-ui'
import { useLocalization } from '@components/Localization'
import * as S from './elements'

type Props = {
  formattedPrice?: string
}

const Price: FC<Props> = ({ formattedPrice }) => {
  const buttonRef = useRef()
  const { messages, lang } = useLocalization()

  return (
    <>
      {formattedPrice ? (
        <Flex alignItems="center" justifyContent={{ _: 'center', large: 'flex-start' }}>
          <Text color="currentColor" mr="0.5rem">
            {messages.rolex.detail.price} {formattedPrice} *
          </Text>
          <Menu>
            <S.MenuButton>
              <S.Button ref={buttonRef}>
                <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
                  <path d="m6.08 8.59.85.36-.17.34c-.03.08-.11.21-.19.38-.1.19-.24.39-.41.59-.18.2-.4.37-.66.51-.27.15-.6.23-.97.23-.41 0-.74-.09-1-.27-.21-.14-.45-.44-.45-1 0-.21.04-.44.11-.68.06-.21.13-.42.19-.6l1.41-4.05h-1.33l.26-.93h3.2l-1.97 5.72c-.05.15-.1.3-.15.46-.03.13-.05.24-.05.35 0 .05.01.07.02.09.01 0 .02.01.05.01.08 0 .18-.04.28-.11.13-.1.26-.21.37-.34.12-.13.22-.26.3-.4.08-.15.13-.26.17-.34zm1.32-8.28c-.21-.2-.47-.31-.77-.31s-.56.11-.76.31-.31.48-.31.78.11.56.31.77.47.31.76.31.56-.11.77-.31c.2-.21.31-.48.31-.77 0-.3-.11-.57-.31-.78z" />
                </svg>
              </S.Button>
              <S.Tip />
            </S.MenuButton>
            <S.MenuList>
              <MenuLink>
                <Text variant="smallDescription">
                  {lang === 'nl'
                    ? `Alle prijzen zijn Rolex adviesprijzen inclusief btw.De prijzen van de met edelstenen bezette modellen zijn onderhevig aan marktschommelingen en kunnen daarom variëren. Rolex behoudt zich het recht voor de prijzen en modellen op deze website te allen tijde te wijzigen.`
                    : `All prices are Rolex's suggested retail price inclusive of V.A.T. The prices of
                    gem-set models are dependent on market fluctuations and therefore subject to
                    variations. Rolex reserves the right to modify the prices and models on this
                    website at any time.`}
                </Text>
              </MenuLink>
            </S.MenuList>
          </Menu>
        </Flex>
      ) : (
        <Text color="currentColor">{messages.rolex.detail.priceOnRequest}</Text>
      )}
    </>
  )
}

export default Price
